export const productThumbnailStyles = {
    container: {
        width: '100px',
        maxWidth: '100px',
        height: '150px',
        maxHeight: '150px',
        ml: 'auto',
        overflow: 'hidden',
        borderRadius: '2px',
        background: 'gray.50',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    image: {
        width: '100%',
        height: '100%',
        objectFit: 'contain'
    }
}

export const writeReviewCollectifBannerStyles = {
    container: {
        background: 'warmWhite',
        padding: '16px',
        marginTop: '16px'
    },
    title: {
        fontSize: 'sm',
        fontWeight: 700,
        textTransform: 'uppercase',
        lineHeight: '20px',
        marginBottom: '8px'
    },
    body: {
        fontSize: 'xs',
        lineHeight: '18px',
        color: 'black'
    },
    link: {
        textDecoration: 'underline',
        fontWeight: 700
    }
}

